<template>
	<ui-card
		icon="fal fa-sitemap"
		title="Origens de Atendimento"
		text="Defina as regras relacionadas às origens dos clientes."
	>
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<ui-util-box-text-slot title="Habilitar inserção de novas origens nos clientes.">
					<ui-switch
						v-model="checked.insert"
						:checked="checked.insert"
						@input="updateCustomerTagsInsert"
						design="xs"
					/>
				</ui-util-box-text-slot>
			</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
		</template>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSwitch } from '@/components/ui/form'
	import { uiUtilBoxTextSlot } from '@/components/ui/form/util'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig } from '../../util/methods'

	const defaultForm = () => ({
		customerTags: null,
	})

	const defaultDisabled = () => ({})

	const defaultChecked = () => ({
		insert: false,
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'configuration-customers-origens',

		components: {
			uiCard,
			uiButton,
			uiSwitch,
			uiLoadSuccess,
			uiLoadIndicator,
			uiUtilBoxTextSlot,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				checked: { ...defaultChecked() },
				loader: { ...defaultLoader() },
				oldForm: {},
			}
		},

		async created() {
			this.loader.body = true
			this.form.customerTags = await this.getConfig('customerTags', 'value_long')
			this.checked.insert = this.$mx_checkIsActive(this.form.customerTags.insert)
			this.loader.body = false
			this.$mx_copyOldForm()
		},

		computed: {
			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body
			},
		},

		methods: {
			getConfig,
			saveConfig,

			updateCustomerTagsInsert(value) {
				this.form.customerTags.insert = this.$mx_activeOrInactive(value)
			},

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await this.saveConfig('customerTags', this.form.customerTags, 'value_long')

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
